/*
 * Modals Manager
 * Adds .no-scroll helper to body when necessary
 */
const BODY_NO_SCROLL_CLASS = 'no-scroll'
const MODAL_VISIBLE_CLASS = 'is-visible'

export default {
  init(scope) {
    const self = this

    $('[data-target-modal]', scope).each(function () {
      const $element = $(this)
      const targetSelector = $element.data('target-modal')

      if (targetSelector) {
        const $target = $(targetSelector)

        $element.click(function () {
          self.toggle(targetSelector)
          $target.toggleClass(MODAL_VISIBLE_CLASS)
        })
      }
    })
  },
  opened: [],
  add(modalName) {
    if (this.opened.indexOf(modalName) < 0) {
      this.opened.push(modalName)
    }

    if (this.active()) {
      this.disableScroll()
    }
  },
  remove(modalName) {
    const index = this.opened.indexOf(modalName)

    if (index >= 0) {
      this.opened.splice(this.opened.indexOf(modalName), 1)
    }

    if (!this.active()) {
      this.enableScroll()
    }
  },
  toggle(modalName) {
    const index = this.opened.indexOf(modalName)

    if (index >= 0) {
      this.remove(modalName)
    } else {
      this.add(modalName)
    }
  },
  disableScroll() {
    $('.app, .header, .top-bar').width($('.app').outerWidth(false))
    $('body').addClass(BODY_NO_SCROLL_CLASS)
  },
  enableScroll() {
    $('.app, .header, .top-bar').css('width', '')
    $('body').removeClass(BODY_NO_SCROLL_CLASS)
  },
  active() {
    return !!this.opened.length
  },
}
